"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeClasses = void 0;
/**
 * Function to return whether value is falsy or an empty object/array
 * @param value The value to test
 * @returns the test result
 */
var isValueTruthy = function (value) {
    if (!value)
        return false;
    if (Array.isArray(value))
        return value.length > 0;
    if (typeof value === 'object')
        return Object.keys(value).length > 0;
    return Boolean(value);
};
/**
 * Function used to reduce classes into a single string
 * @param classes The list of classes to filter/merge
 * @returns A string concatenating given classes
 */
var reduceArray = function (classes) {
    return classes
        .reduce(function (list, currentClass) {
        var cleanClasses = cleanClass(currentClass);
        return cleanClasses ? "".concat(list, " ").concat(cleanClasses) : list;
    }, '')
        .trim();
};
/**
 * Utilisty function to remove empty classes and flatten every other types
 * @param input A single ClassType item
 * @returns The class list found from the item
 */
var cleanClass = function (input) {
    if (!input || !isValueTruthy(input))
        return '';
    if (Array.isArray(input))
        return reduceArray(input);
    if (typeof input === 'object') {
        return cleanClass(Object.entries(input).reduce(function (list, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return (isValueTruthy(value) ? __spreadArray(__spreadArray([], __read(list), false), [key], false) : list);
        }, []));
    }
    return input;
};
var mergeClasses = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return reduceArray(classes);
};
exports.mergeClasses = mergeClasses;
//# sourceMappingURL=style.js.map